<template>
<div class="card">
  <el-alert v-if="showCancelAlert" title="Incomplete payment. Please try again." type="error" show-icon :closable="false" />
   <div class="row">
      <div class="col-md-8 cart background-container">
         <div class="title">
            <div class="row">
               <div class="col">
                  <h4><b>Shopping Cart</b></h4>
               </div>
               <div class="col align-self-center text-right muted-text">{{ totalQuantity }} items</div>
            </div>
         </div>
         <div v-if="shoppingCart.length">
          <hr>
          <div class="row border-bottom" v-for="product in shoppingCart" :key="product.priceId">
            <div class="row main align-items-center">
               <div class="col-2" v-if="product.name.includes('session')"><img class="img-fluid" src="../../assets/images/workout.png"></div>
               <div class="col-2" v-if="product.name.includes('coin')"><img class="img-fluid" src="../../assets/images/tokens.png"></div>
               <div class="col-2" v-if="product.name === 'Glove'"><img class="img-fluid" src="../../assets/images/glove.png"></div>
               <div class="col-2" v-if="product.name === 'Knee Sleeve'"><img class="img-fluid" src="../../assets/images/knee_sleeve.png"></div>
               <div class="col-2" v-if="product.name === 'Pants'"><img class="img-fluid" src="../../assets/images/knee_sleeve.png"></div>
               <div class="col-2" v-if="product.name === 'Band'"><img class="img-fluid" src="../../assets/images/band.jpg"></div>
               <div class="col-2" v-if="product.name === 'Neat'"><img class="img-fluid" src="../../assets/images/neat.png"></div>
               <div class="col">
                  <div class="row muted-text">{{ product.name }}</div>
                  <div class="row"></div>
               </div>
               <div class="col">
                  <a href="#" class="text" @click.prevent="decrementQuantity(product)">-</a><a href="#" class="border text">{{ product.quantity }}</a><a href="#" class="text"  @click.prevent="incrementQuantity(product)">+</a>
               </div>
               <div class="col text">$ {{ product.price * product.quantity }} <span @click="removeProduct(product)" class="text close">&#10005;</span></div>
            </div>
         </div>
         </div>
         <div v-else>
          <el-empty description="Your cart is empty" />
         </div>
      </div>
      <div class="col-md-4 summary">
         <div>
            <h5><b>Summary</b></h5>
         </div>
         <hr class="white-divider">
         <div class="row mt-2">
            <div class="col" style="padding-left:0;">Subtotal</div>
            <div class="col text-right">$ {{ Number(total).toFixed(2) }}</div>
         </div>
         <div class="row mt-2 mb-2">
            <div class="col" style="padding-left:0;">PST (7%)</div>
            <div class="col text-right">$ {{ (Number(total) * 0.07).toFixed(2) }}</div>
         </div>
         <div class="row mt-2 mb-2">
            <div class="col" style="padding-left:0;">GST (5%)</div>
            <div class="col text-right">$ {{ (Number(total) * 0.05).toFixed(2) }}</div>
         </div>
         <!-- <div class="row mt-2 mb-2">
            <div class="col" style="padding-left:0;">Shipping</div>
            <div class="col text-right">$ 0</div>
         </div> -->
         <div class="row" style="border-top: 1px solid var(--border-color); padding: 2vh 0;">
            <div class="col">Total</div>
            <div class="col text-right">$ {{ Number(totalWithTaxes).toFixed(2) }}</div>
         </div>
         <button v-if="!isLoading" class="btn btn-primary" @click="checkout">CHECKOUT</button>
         <button v-else class="btn btn-primary" disabled> <b-spinner small label="Spinning"></b-spinner></button>
      </div>
   </div>
</div>
</template>

<script>
import { xray } from '../../config/pluginInit'
import { useStore } from 'vuex'
import { computed, onMounted, ref } from 'vue'
import firebaseService from '../../../firebase'
import { httpsCallable } from 'firebase/functions'
import { useRoute } from 'vue-router'

const body = document.getElementsByTagName('body')

export default {
  setup () {
    const store = useStore()
    const shoppingCart = computed(() => store.getters['shoppingCart/cartProducts']);
    const total = computed(() => store.getters['shoppingCart/cartTotalPrice']);
    const totalQuantity = computed(() => store.getters['shoppingCart/cartTotalQuantity']);
    const decrementProductQuantity = (product) => store.dispatch('shoppingCart/decrementProductQuantity', product);
    const incrementProductQuantity = (product) => store.dispatch('shoppingCart/incrementProductQuantity', product);
    const removeProductFromCart = (product) => store.dispatch('shoppingCart/removeProductFromCart', product);
    const createCheckoutSession = httpsCallable(firebaseService.functions, 'createCheckoutSession')
    const isLoading = ref(false)
    const route = useRoute()
    const showCancelAlert = ref(false)
    const totalWithTaxes = computed(() => {
      const subtotal = parseFloat(Number(total.value).toFixed(2))
      const pst = parseFloat((Number(total.value) * 0.07).toFixed(2))
      const gst = parseFloat((Number(total.value) * 0.05).toFixed(2))
      return subtotal + pst + gst
    })

    onMounted(() => {
      if (route.name === 'patient.orderCancel') {
        showCancelAlert.value = true
      }
    })
    const decrementQuantity = (product) => {
      decrementProductQuantity(product)
    }

    const incrementQuantity = (product) => {
      incrementProductQuantity(product)
    }

    const removeProduct = (product) => {
      removeProductFromCart(product.priceId)
    }

    const checkout = async () => {
      if (!shoppingCart.value.length) {
        return
      }
      isLoading.value = true
      const lineItems = []
      shoppingCart.value.forEach(product => {
        lineItems.push({
          price: product.priceId,
          quantity: product.quantity,
          tax_rates: ['txr_1N8vtOA844XXZODAqyNn5hon', 'txr_1N8vsIA844XXZODAJyVpKPaa']
        })
      })

      try {
        const response = await createCheckoutSession({ lineItems: lineItems, uid: firebaseService.firebaseAuth.currentUser.uid })
        console.log(response)
        window.location.href = response.data.url
        isLoading.value = false
      } catch (error) {
        console.log(error)
      }
    }
    return {
      shoppingCart,
      total,
      totalQuantity,
      decrementQuantity,
      incrementQuantity,
      removeProduct,
      checkout,
      showCancelAlert,
      isLoading,
      totalWithTaxes
    }
  },
  mounted () {
    xray.index()
    body[0].classList.add('sidebar-main-menu')
  },
  unmounted () {
    body[0].classList.remove('sidebar-main-menu')
  }
}
</script>

<style scoped>
body[data-theme="night"] .white-divider {
  border-top: 1px solid white !important;
}
body{
    background: #ddd;
    min-height: 100vh;
    vertical-align: middle;
    display: flex;
    font-family: sans-serif;
    font-size: 0.8rem;
    font-weight: bold;
}
.title{
    margin-bottom: 3vh;
    padding: 10px 0;
    background-color: var(--light-grey);
}
.card{
    margin: auto;
    width: 95%;
    border-radius: 1rem;
    border: transparent;
    margin-bottom: 30px;
}
@media(max-width:767px){
    .card{
        margin: 3vh auto;
    }
}

.cart{
    background-color: #fff;
    padding: 4vh 5vh;
    border-bottom-left-radius: 1rem;
    border-top-left-radius: 1rem;
}
@media(max-width:767px){
    .cart{
        padding: 4vh;
        border-bottom-left-radius: unset;
        border-top-right-radius: 1rem;
    }
}
.summary{
    background-color: #ddd;
    border-top-right-radius: 1rem;
    border-bottom-right-radius: 1rem;
    padding: 4vh;
    color: rgb(65, 65, 65);
}
@media(max-width:767px){
    .summary{
    border-top-right-radius: unset;
    border-bottom-left-radius: 1rem;
    }
}
.summary .col-2{
    padding: 0;
}
.summary .col-10
{
    padding: 0;
}.row{
    margin: 0;
}
.title b{
    font-size: 1.5rem;
}
.main{
    margin: 0;
    padding: 2vh 0;
    width: 100%;
}
.col-2, .col{
    padding: 0 1vh;
}
a{
    padding: 0 1vh;
}
.close{
    margin-left: auto;
    font-size: 0.7rem;
    margin-top: 5px;
    cursor: pointer;
}
img{
    width: 3.5rem;
}
.back-to-shop{
    margin-top: 4.5rem;
}
h5{
    margin-top: 4vh;
}

form{
    padding: 2vh 0;
}
select{
    border: 1px solid rgba(0, 0, 0, 0.137);
    padding: 1.5vh 1vh;
    margin-bottom: 4vh;
    outline: none;
    width: 100%;
    background-color: rgb(247, 247, 247);
}
input{
    border: 1px solid rgba(0, 0, 0, 0.137);
    padding: 1vh;
    margin-bottom: 4vh;
    outline: none;
    width: 100%;
    background-color: rgb(247, 247, 247);
}
input:focus::-webkit-input-placeholder
{
      color:transparent;
}
.btn{
    color: white;
    width: 100%;
    font-size: 0.7rem;
    margin-top: 4vh;
    padding: 1vh;
    border-radius: 0;
}
.btn:focus{
    box-shadow: none;
    outline: none;
    box-shadow: none;
    color: white;
    -webkit-box-shadow: none;
    -webkit-user-select: none;
    transition: none;
}
.btn:hover{
    color: white;
}
a{
    color: black;
}
a:hover{
    color: black;
    text-decoration: none;
}
 #code{
    background-image: linear-gradient(to left, rgba(255, 255, 255, 0.253) , rgba(255, 255, 255, 0.185)), url("https://img.icons8.com/small/16/000000/long-arrow-right.png");
    background-repeat: no-repeat;
    background-position-x: 95%;
    background-position-y: center;
}
</style>
